module.exports = __webpack_public_path__ + "static/img/fengmian.fb0414c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/source/fengmian.jpg
// module id = oykv
// module chunks = 4